import {Tag} from "antd";
import React from "react";

export const DraftIndicator = ({ definitionState }) => {

  return definitionState === 'DRAFT' && <span style={{alignContent: "center"}}>&nbsp;<Tag bordered={false} color="volcano">Draft</Tag></span>

};